import React, { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { SidebarLayout } from '@/components/layouts/SidebarLayout'

export default function New() {
  const { data, setData, post, processing, errors } = useForm({
    runner: {
      name: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/manage/runners')
  }

  return (
    <SidebarLayout section="manage" title="New runner">
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          maxWidth: 600,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="Name"
            fullWidth
            autoFocus
            value={data.runner.name}
            onChange={e => setData('runner', { ...data.runner, name: e.target.value })}
            error={'runner.name' in errors}
            helperText={(errors as Record<string, string>)['runner.name'] || 'Only letters, numbers, underscores, and hyphens'}
            sx={{ mb: 3 }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled={processing}
            sx={{ mb: 2 }}
          >
            Create runner
          </Button>
          <Box sx={{ textAlign: 'center' }}>
            <Link href="/manage/runners" style={{ color: '#1a1a1a' }}>Back to runners</Link>
          </Box>
        </Box>
      </Paper>
    </SidebarLayout>
  )
}
